/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})()

if (typeof LogoSlider !== "function") {
  class LogoSlider extends HTMLElement {
    constructor() {
      super()
      this.mainSwiper = null
      this.thumbsSwiper = null
      this.mainSlider = this.querySelector('.mainSwiper')
      this.thumbsSlider = this.querySelector('.thumbsSwiper')

      this.thumbsSliderSettings = {
        loop: true,
        slidesPerGroup: 1,
        slidesPerView: 3,
        spaceBetween: 20,
        watchSlidesProgress: true,
      }

      this.mainSettings = {
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        slidesPerView: 1,
        spaceBetween: 0,
        thumbs: {
          swiper: this.thumbsSlider,
        },
      }

      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
      this.initSlider()
    }
    initSlider() {
      if (this.thumbsSwiper && this.thumbsSwiper.destroy) {
        this.thumbsSwiper.destroy()
        this.thumbsSwiper = null
      }
      if (this.mainSwiper && this.mainSwiper.destroy) {
        this.mainSwiper.destroy()
        this.mainSwiper = null
      }
      this.mainSwiper = new Swiper(this.mainSlider, this.mainSettings)
      this.thumbsSwiper = new Swiper(this.thumbsSlider, this.thumbsSliderSettings)
    }
  }

  customElements.define('logo-slider', LogoSlider)
}

if (typeof CustomProduct !== "function") {
  class CustomProduct extends HTMLElement {
    constructor() {
      super()
      this.variant = JSON.parse(this.dataset.variants)
      this.allToTop = this.dataset.allToTop
      this.limlitedMediaTemplate = this.querySelector('.custom__product__limited_media')
      this.allMediaTemplate = this.querySelector('.custom__product__all_media')
      this.idInput = this.querySelector('[name="id"]')
      this.inventoryContainer = this.querySelector('[data-inventory]')
      this.infoOptions = this.querySelectorAll('.custom__product__info .radio__fieldset .radio__button input')
      this.formOptions = this.querySelectorAll('.product__content .radio__fieldset .radio__button input')
      this.infoErrors = this.querySelector('.custom__product__info .product__form__errors')
      this.formErrors = this.querySelector('.product__submit .product__form__errors')
      this.options = this.querySelectorAll('.radio__fieldset .radio__button input')
      this.customProductWrapper = this.querySelector('.custom__product__wrapper')
      this.infoSubmit = this.querySelector('.custom__product__info .btn')
      this.formSubmit = this.querySelector('.product__submit .btn')
      this.mainSwiper = null
      this.mainSwiperMobi = null
      this.topSwiperDesk = null
      this.topSwiperMobi = null
      this.mainSliderMobi = this.querySelector('.product__block.product__gallery .mainSwiper')
      this.mainSlider = this.querySelector('.mainSwiper')
      this.topSliderDesk = this.querySelector('.topSwiper.deskOnly')
      this.topSliderMobi = this.querySelector('.topSwiper.mobiOnly')
      this.mainSettings = {
        centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: this.mainSlider.querySelector(".swiper-button-next"),
          prevEl: this.mainSlider.querySelector(".swiper-button-prev"),
        },
        on: {
          slideChangeTransitionEnd: (s) => {
            Array.from(s.el.querySelectorAll('video')).forEach(v => v.pause())

            s.el.querySelector('.swiper-slide-active .deferred-media__poster')?.click()
            setTimeout(() => s.el.querySelector('.swiper-slide-active video')?.play(), 10)
          }
        },
        pagination: {
          el: this.mainSlider.querySelector(".main-pagination"),
          type: "fraction",
        },
        slidesPerView: 1,
        spaceBetween: 0,
      }
      this.mainSettingsMobi = {
        centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: this.mainSliderMobi.querySelector(".swiper-button-next"),
          prevEl: this.mainSliderMobi.querySelector(".swiper-button-prev"),
        },
        on: {
          slideChangeTransitionEnd: (s) => {
            Array.from(s.el.querySelectorAll('video')).forEach(v => v.pause())

            s.el.querySelector('.swiper-slide-active .deferred-media__poster')?.click()
            setTimeout(() => s.el.querySelector('.swiper-slide-active video')?.play(), 10)
          }
        },
        pagination: {
          el: this.mainSliderMobi.querySelector(".main-pagination"),
          type: "fraction",
        },
        slidesPerView: 1,
        spaceBetween: 0,
      }
      this.topSettings = {
        breakpoints: {
          750: {
            slidesPerView: 3,
          }
        },
        loop: false,
        on: {
          init: (s) => {
            Array.from(s.el.querySelectorAll('.deferred-media__poster')).forEach((el) => el.click())
            setTimeout(() => s.el.querySelector('.swiper-slide-active video')?.play(), 10)
          },
          slideChangeTransitionEnd: (s) => {
            Array.from(s.el.querySelectorAll('video')).forEach(v => v.pause())

            s.el.querySelector('.swiper-slide-active .deferred-media__poster')?.click()
            setTimeout(() => s.el.querySelector('.swiper-slide-active video')?.play(), 10)
          }
        },
        pagination: {
          el: ".top-pagination"
        },
        slidesPerView: 1,
        spaceBetween: 0,
      }

      // this.mediaHandle()
      this.init()
      this.scrollDef()

      document.addEventListener("shopify:section:load", (event) => {
        // this.mediaHandle()
        this.init()
        this.scrollDef()
      })
      window.addEventListener('resize', () => {
        // this.mediaHandle()
        this.scrollDef()
      })
      document.addEventListener("readystatechange", (event) => {
        if (event.target.readyState === "complete") {
          this.scrollDef()
        }
      })

      this.infoSubmit?.addEventListener('click', () => this.formSubmit.click())
    }
    init() {
      this.initSlider()

      Array.from(this.formOptions).forEach((el, i) => {
        const target = this.querySelector(`.custom__product__info .radio__fieldset .radio__button label[for="${el.id}"]`)
        if (target) target.className = el.className
      })

      const submitConfig = {
        attributes: true,
      }
      const submitCallback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === "attributes") {
            if (this.infoSubmit) this.infoSubmit.classList = mutation.target.classList
          }
        }
      }
      const submitObserver = new MutationObserver(submitCallback)
      submitObserver.observe(this.formSubmit, submitConfig)

      const errorsConfig = {
        attributes: true,
        childList: true,
        subtree: true
      }
      const errorsCallback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          this.infoErrors.classList = mutation.target.classList
          this.infoErrors.innerHTML = mutation.target.innerHTML

          Array.from(this.infoErrors.querySelectorAll(".errors__close")).forEach(el => {
            el.addEventListener('click', () => (this.infoErrors.classList.remove('is-visible')))
          })
        }
      }
      const errorsObserver = new MutationObserver(errorsCallback)
      errorsObserver.observe(this.formErrors, errorsConfig)

      Array.from(this.options).forEach(el => {
        if (el.checked) Array.from(this.querySelectorAll(`label[for="${el.id}"]`)).forEach(l => l.classList.add('radio__button-selected'))

        el.addEventListener("change", () => {
          Array.from(this.querySelectorAll(`.radio__button-selected`)).forEach(l => l.classList.remove('radio__button-selected'))
          Array.from(this.querySelectorAll(`label[for="${el.id}"]`)).forEach(l => (l.classList.add('radio__button-selected')))
        })
      })

      this.idInput.addEventListener('change', () => {
        if (this.variant[`${this.idInput.value}`] > 0 && this.variant[`${this.idInput.value}`] < 6) this.inventoryContainer.textContent = 'only a few left'
        else this.inventoryContainer.textContent = ''
      })
    }
    initSlider() {
      if (this.mainSwiper && this.mainSwiper.destroy) {
        this.mainSwiper.destroy()
        this.mainSwiper = null
      }
      this.mainSwiper = new Swiper(this.mainSlider, this.mainSettings)

      if (this.mainSliderMobi) {
        if (this.mainSwiperMobi && this.mainSwiperMobi.destroy) {
          this.mainSwiperMobi.destroy()
          this.mainSwiperMobi = null
        }
        this.mainSwiper = new Swiper(this.mainSliderMobi, this.mainSettingsMobi)
      }

      if (this.topSwiperDesk && this.topSwiperDesk.destroy) {
        this.topSwiperDesk.destroy()
        this.topSwiperDesk = null
      }
      this.topSwiperDesk = new Swiper(this.topSliderDesk, this.topSettings)

      if (this.topSwiperMobi && this.topSwiperMobi.destroy) {
        this.topSwiperMobi.destroy()
        this.topSwiperMobi = null
      }
      this.topSwiperMobi = new Swiper(this.topSliderMobi, this.topSettings)
    }
    scrollDef() {
      this.style.setProperty('--bottom', `${this.customProductWrapper.scrollHeight > window.innerHeight ? this.customProductWrapper.scrollHeight - window.innerHeight : 0}px`)
    }
    mediaHandle() {
      if(this.topSlider.querySelector('.swiper-wrapper')) this.topSlider.querySelector('.swiper-wrapper').remove();

      this.topSlider.append(this.allToTop === 'true' && window.innerWidth < 768 ? this.allMediaTemplate.content.cloneNode(true) : this.limlitedMediaTemplate.content.cloneNode(true))

      if (this.topSwiper && this.topSwiper.destroy) {
        this.topSwiper.destroy()
        this.topSwiper = null
      }
      this.topSwiper = new Swiper(this.topSlider, this.topSettings)
    }
  }

  customElements.define('custom-product', CustomProduct)
}

if (typeof CustomHeader !== "function") {
  class CustomHeader extends HTMLElement {
    constructor() {
      super()
      this.topSwiper = null
      this.topSlider = this.querySelector('.topSwiper')
      this.topSettings = {
        breakpoints: {
          750: {
            slidesPerView: 2,
          }
        },
        loop: false,
        on: {
          slideChangeTransitionEnd: (s) => {
            Array.from(s.el.querySelectorAll('video')).forEach(v => v.pause())

            s.el.querySelector('.swiper-slide-active .deferred-media__poster')?.click()
            setTimeout(() => s.el.querySelector('.swiper-slide-active video')?.play(), 10)
          }
        },
        pagination: {
          el: ".top-pagination"
        },
        slidesPerView: 1,
        spaceBetween: 0,
      }

      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
      this.initSlider()
    }
    initSlider() {
      if (this.topSwiper && this.topSwiper.destroy) {
        this.topSwiper.destroy()
        this.topSwiper = null
      }
      this.topSwiper = new Swiper(this.topSlider, this.topSettings)
    }
  }

  customElements.define('custom-header', CustomHeader)
}

if (typeof BrickSlider !== "function") {
  class BrickSlider extends HTMLElement {
    constructor() {
      super()
      this.mainSwiper = null
      this.mainSlider = this.querySelector('.brickSwiper')
      this.mainSettings = {
        breakpoints: {
          750: {
            loop: false,
            slidesPerView: 2,
          }
        },
        loop: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        slidesPerView: 1,
        spaceBetween: 0,
      }

      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
      this.initSlider()
    }
    initSlider() {
      if (this.mainSwiper && this.mainSwiper.destroy) {
        this.mainSwiper.destroy()
        this.mainSwiper = null
      }
      this.mainSwiper = new Swiper(this.mainSlider, this.mainSettings)

      if (this.topSwiper && this.topSwiper.destroy) {
        this.topSwiper.destroy()
        this.topSwiper = null
      }
      this.topSwiper = new Swiper(this.topSlider, this.topSettings)
    }
  }

  customElements.define('brick-slider', BrickSlider)
}

if (typeof WelCome !== "function") {
  class WelCome extends HTMLElement {
    constructor() {
      super()
      this.welcomeLogos = this.querySelector('.welcome__logos')
      this.firstLogo = this.querySelector('.welcome__logo_image:first-child')
      this.secondLogo = this.querySelector('.welcome__logo_image:nth-child(2)')

      this.init()
      document.addEventListener("shopify:section:load", (event) => this.init())
      window.addEventListener('resize', () => this.init())
      window.addEventListener('scroll', () => this.scroll())
    }
    init() {
      if (window.innerWidth > 479) {
        this.leftLogo = document.querySelector('.header__desktop .header__desktop__bar__l .header__logo--image')
        this.rightLogo = document.querySelector('.header__desktop .header__desktop__bar__r .header__logo--image')
      } else {
        this.leftLogo = document.querySelector('.header__mobile .header__mobile__left .header__logo--image')
        this.rightLogo = document.querySelector('.header__mobile .header__mobile__right .header__logo--image')
      }

      const element = document.querySelector('html')
      const computedStyles = getComputedStyle(element)
      const cssVariableValue = parseInt(computedStyles.getPropertyValue('--header-height').trim().replace(/px|%/g, ''))
      document.body.classList.toggle('iAmIn', true)

      const leftWidth = `${Math.max(this.leftLogo.scrollWidth, this.welcomeLogos.scrollWidth - (window.scrollY / (window.innerHeight - (cssVariableValue + 200))) * (this.welcomeLogos.scrollWidth - this.leftLogo.scrollWidth))}px`;
      if (this.firstLogo) this.firstLogo.style.width = leftWidth;

      const rightWidth = `${Math.max(this.rightLogo.scrollWidth, this.welcomeLogos.scrollWidth - (window.scrollY / (window.innerHeight - (cssVariableValue + 200))) * (this.welcomeLogos.scrollWidth - this.rightLogo.scrollWidth))}px`;
      if (this.secondLogo) this.secondLogo.style.width = rightWidth;
    }
    scroll() {
      const element = document.querySelector('html')
      const computedStyles = getComputedStyle(element)
      const cssVariableValue = parseInt(computedStyles.getPropertyValue('--header-height').trim().replace(/px|%/g, ''))

      if (window.scrollY < (window.innerHeight - (cssVariableValue + 200))) {
        document.body.classList.toggle('iAmIn', true)

        const leftWidth = `${Math.max(this.leftLogo.scrollWidth, this.welcomeLogos.scrollWidth - (window.scrollY / (window.innerHeight - (cssVariableValue + 200))) * (this.welcomeLogos.scrollWidth - this.leftLogo.scrollWidth))}px`;
        if (this.firstLogo) this.firstLogo.style.width = leftWidth;

        const rightWidth = `${Math.max(this.rightLogo.scrollWidth, this.welcomeLogos.scrollWidth - (window.scrollY / (window.innerHeight - (cssVariableValue + 200))) * (this.welcomeLogos.scrollWidth - this.rightLogo.scrollWidth))}px`;
        if (this.secondLogo) this.secondLogo.style.width = rightWidth;
      } else {
        document.body.classList.toggle('iAmIn', false)
        if (this.firstLogo) this.firstLogo.style.width = `${this.leftLogo.scrollWidth}px`;
        if (this.secondLogo) this.secondLogo.style.width = `${this.rightLogo.scrollWidth}px`;
      }
    }
  }

  customElements.define('welcome-section', WelCome)
}

if (typeof DropAndPlay !== "function") {
  class DropAndPlay extends HTMLElement {
    constructor() {
      super()
      this.playCanvasWrapper = this.querySelector('.playCanvasWrapper')
      this.playDresses = this.querySelector('.playDresses')
      this.playBodies = this.querySelector('.playBodies')
      this.dresses = this.querySelectorAll('.dressWrapper')
      this.bodies = this.querySelectorAll('.bodyWrapper')

      this.dressesSlider = this.querySelector('.dressesSwiper')
      this.dressesSwiper = null
      this.dressesSettings = {
        allowTouchMove: false,
        loop: true,
        navigation: {
          nextEl: this.querySelector(".playDressesButtonNext"),
          prevEl: this.querySelector(".playDressesButtonPrev"),
        },
        slidesPerView: 3,
        spaceBetween: 0,
      }

      this.bodiesSlider = this.querySelector('.bodiesSwiper')
      this.bodiesSwiper = null
      this.bodiesSettings = {
        allowTouchMove: false,
        loop: true,
        navigation: {
          nextEl: this.querySelector(".playBodiesButtonNext"),
          prevEl: this.querySelector(".playBodiesButtonPrev"),
        },
        slidesPerView: 5.5,
        spaceBetween: 0,
      }

      this.dressModel = {
        // body: this.bodies[0].dataset.image,
        both: '',
        upper: '',
        bottom: '',
      }

      Array.from(this.bodies).forEach(body => {
        body.addEventListener('click', () => {
          const dressModelBody = this.querySelector('.dressModelBody')
          this.dressModel.body = body.dataset.image

          // this.applySizes(body.closest('.swiper-slide'))
          dressModelBody.innerHTML = ''
          const bodyImg = new Image()
          bodyImg.src = this.dressModel.body
          bodyImg.onload = () => dressModelBody.append(bodyImg)
        })
      })

      this.init()
      document.addEventListener("shopify:section:load", () => {
        this.init()
      })

      document.addEventListener("shopify:block:select", (e) => {
        const shopifyEditorBlock = JSON.parse(e.target.dataset.shopifyEditorBlock)
        this.dressModel.both = ''

        if (shopifyEditorBlock.type == "body" || shopifyEditorBlock.type == "dress") {
          if (e.target.dataset.type) {
            this.dressModel[e.target.dataset.type] = e.target.dataset.image
          } else {
            // this.applySizes(e.target)
            this.dressModel.body = e.target.dataset.image
          }
          this.drawModel()
        }
      })
    }
    init() {
      // this.applySizes(this.bodies[0].closest('.swiper-slide'))
      this.initSlider()
      this.drawModel()

      this.addEventListener('dragstart', (e) => {
        this.dragItem = e.target
        e.dataTransfer.setData('text/plain', '')
        e.target.style.opacity = '0.5'
      })

      this.addEventListener('dragend', () => {
        if (this.dragItem) this.dragItem.style.opacity = '1'
        this.dragItem = null
      })

      this.querySelector('.dressModelInner').addEventListener('dragover', (e) => {
        e.preventDefault()
      })

      this.querySelector('.dressModelInner').addEventListener('drop', (e) => {
        e.preventDefault()
        this.dressModel.both = ''

        if (this.dragItem.dataset.type) {
          this.dressModel[this.dragItem.dataset.type] = this.dragItem.closest('.dressWrapper').dataset.image
        } else {
          // this.applySizes(this.dragItem.closest('.swiper-slide'))
          this.dressModel.body = this.dragItem.src
        }

        this.drawModel()
      })
    }
    initSlider() {
      if (this.dressesSwiper && this.dressesSwiper.destroy) {
        this.dressesSwiper.destroy()
        this.dressesSwiper = null
      }
      this.dressesSwiper = new Swiper(this.dressesSlider, this.dressesSettings)

      if (this.bodiesSwiper && this.bodiesSwiper.destroy) {
        this.bodiesSwiper.destroy()
        this.bodiesSwiper = null
      }
      this.bodiesSwiper = new Swiper(this.bodiesSlider, this.bodiesSettings)
    }
    drawModel() {
      const dressModelBody = this.querySelector('.dressModelBody')
      const dressModelBoth = this.querySelector('.dressModelBoth')
      const dressModelUpper = this.querySelector('.dressModelUpper')
      const dressModelBottom = this.querySelector('.dressModelBottom')

      /* dressModelBody.innerHTML = ''
      if (this.dressModel.body != "") {
        const bodyImg = new Image()
        bodyImg.src = this.dressModel.body
        bodyImg.onload = () => dressModelBody.append(bodyImg)
      } */
      dressModelBoth.innerHTML = ''

      if (this.dressModel.both != "") {
        dressModelUpper.innerHTML = ''
        dressModelBottom.innerHTML = ''
        const bothImg = new Image()
        bothImg.src = this.dressModel.both
        bothImg.onload = () => dressModelBoth.append(bothImg)
      } else {
        if (this.dressModel.upper != "") {
          dressModelUpper.innerHTML = ''
          const upperImg = new Image()
          upperImg.src = this.dressModel.upper
          upperImg.onload = () => dressModelUpper.append(upperImg)
        }
        if (this.dressModel.bottom != "") {
          dressModelBottom.innerHTML = ''
          const bottomImg = new Image()
          bottomImg.src = this.dressModel.bottom
          bottomImg.onload = () => dressModelBottom.append(bottomImg)
        }
      }
    }
    applySizes(el) {
      const sizes = JSON.parse(el.dataset.size)
      this.style.setProperty('--upper-size', `${sizes.upper}%`)
      this.style.setProperty('--lower-size', `${sizes.lower}%`)
    }
  }

  if (!customElements.get('drop-and-play')) customElements.define('drop-and-play', DropAndPlay)
}

if (typeof ReviewSection !== "function") {
  class ReviewSection extends HTMLElement {
    constructor() {
      super()
      this.reviewSlider = this.querySelector('.reviewSwiper')
      this.reviewSwiper = null
      this.reviewSettings = {
        loop: true,
        navigation: {
          nextEl: this.querySelector(".reviewButtonNext"),
          prevEl: this.querySelector(".reviewButtonPrev"),
        },
        slidesPerView: 3,
        spaceBetween: 100,
      }

      if (this.querySelector("[data-oke-reviews-product-id]")) {
        document.addEventListener('readystatechange', () => {
          if (document.readyState === "complete") this.init()
        })
        document.addEventListener("shopify:section:load", () => {
          this.init()
        })
      } else {
        this.querySelector('.reviews__wrapper').innerHTML = `<div class="wrapper--full-padded text-center">This section will only work with \"Okendo Reviews Widget\".</div>`
      }
    }
    async init() {
      this.average = this.querySelector('.oke-w-ratingAverageModule-rating-average')
      this.reviews = this.querySelectorAll('.oke-w-review-content')
      this.writeReview = this.querySelector('.oke-w-writeReview')
      this.leave_a_review = this.querySelector('.leave_a_review')
      this.showMore = this.querySelector('.oke-showMore-button')
      this.viewMore = this.querySelector('.hidden-context .viewMore')
      this.emptyState = this.querySelector('.oke-state-empty-text')
      Array.from(this.reviews).forEach(review => {
        const reviewContent = review.cloneNode(true)
        const swiperSlide = document.createElement('div')
        swiperSlide.className = "swiper-slide"
        swiperSlide.append(reviewContent)

        const reviewName = document.createElement('strong')
        reviewName.className = "oke-w-reviewer-name"
        reviewName.innerText = review.closest('.oke-w-review').querySelector('.oke-w-reviewer-name').textContent
        reviewName.style.display = 'block'
        reviewName.style.marginTop = '.5em'
        reviewName.style.textTransform = 'capitalize'

        swiperSlide.querySelector('.oke-reviewContent-stars').append(reviewName)
        this.reviewSlider.querySelector('.swiper-wrapper').append(swiperSlide)
      })

      this.querySelector('.reviews__average').classList.remove('hidden')
      this.querySelector('.reviews__average').innerHTML = `${this.average?.textContent || 0} STARS`
      if (this.showMore) {
        this.viewMore.addEventListener('click', () => {
          this.showMore.click()
        })
      }

      if (this.emptyState) {
        const nowReview = document.createElement('div')
        nowReview.className = "oke-state-empty-text"
        nowReview.innerText = this.emptyState.textContent

        this.querySelector('.reviews__slider').append(nowReview)
        this.querySelector('.reviews__average').classList.add('hidden')
      }

      this.leave_a_review.addEventListener('click', () => this.writeReview.click())
      this.initSlider()
    }
    initSlider() {
      if (this.reviewSwiper && this.reviewSwiper.destroy) {
        this.reviewSwiper.destroy()
        this.reviewSwiper = null
      }
      this.reviewSwiper = new Swiper(this.reviewSlider, this.reviewSettings)
    }
  }

  customElements.define('custom-reviews', ReviewSection)
}

if (typeof DeeperMeaning !== "function") {
  class DeeperMeaning extends HTMLElement {
    constructor() {
      super()
      this.deeperMeaningSlider = this.querySelector('.deeper_meaning-swiper')
      this.deeperMeaningSwiper = null
      this.deeperMeaningSettings = {
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 2,
            spaceBetween: 40,
          }
        },
        loop: true,
        navigation: {
          nextEl: this.querySelector(".deeper_meaning_button-next"),
          prevEl: this.querySelector(".deeper_meaning_button-prev"),
        },
        slidesPerView: 1,
        spaceBetween: 0,
      }

      this.init()
      document.addEventListener("shopify:section:load", () => {
        this.init()
      })
    }
    init() {
      this.initSlider()
    }
    initSlider() {
      if (this.deeperMeaningSwiper && this.deeperMeaningSwiper.destroy) {
        this.deeperMeaningSwiper.destroy()
        this.deeperMeaningSwiper = null
      }
      this.deeperMeaningSwiper = new Swiper(this.deeperMeaningSlider, this.deeperMeaningSettings)
    }
  }

  customElements.define('deeper-meaning', DeeperMeaning)
}

if (typeof FullSlider !== "function") {
  class FullSlider extends HTMLElement {
    constructor() {
      super()
      this.topSwiper = null
      this.topSlider = this.querySelector('.topSwiper')
      this.topSettings = {
        breakpoints: {
          750: {
            slidesPerView: 3,
          }
        },
        loop: false,
        on: {
          slideChangeTransitionEnd: (s) => {
            Array.from(s.el.querySelectorAll('video')).forEach(v => v.pause())

            s.el.querySelector('.swiper-slide-active .deferred-media__poster')?.click()
            setTimeout(() => s.el.querySelector('.swiper-slide-active video')?.play(), 10)
          }
        },
        pagination: {
          el: ".top-pagination"
        },
        slidesPerView: 1,
        spaceBetween: 0,
      }

      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
      this.initSlider()
    }
    initSlider() {
      if (this.topSwiper && this.topSwiper.destroy) {
        this.topSwiper.destroy()
        this.topSwiper = null
      }
      this.topSwiper = new Swiper(this.topSlider, this.topSettings)
    }
  }

  customElements.define('full-slider', FullSlider)
}

if (typeof ModelsGallery !== "function") {
  class ModelsGallery extends HTMLElement {
    constructor() {
      super()
      this.menu = this.querySelector('.modelsGalleryMenu')
      this.filters = this.querySelector('.modelsGalleryMenuItemFilter')
      this.optionList = this.querySelector('.modelsGalleryFilterOptions')

      this.items = this.querySelectorAll('.modelItem')
      this.popups = this.querySelectorAll('.modelsGalleryPopup')
      this.options = this.querySelectorAll('.modelsGalleryFilterOption')
      this.popupLinks = this.querySelectorAll('.modelsGalleryMenuItemPopup .modelsGalleryLink')

      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
      if (this.filters) this.filters.querySelector('.modelsGalleryLink').addEventListener('click', () => {
        if (this.optionList) this.optionList.classList.toggle('modelsGalleryFilterOptionsOpens', !this.optionList.classList.contains('modelsGalleryFilterOptionsOpens'))
      })

      Array.from(this.options).forEach(el => {
        el.addEventListener('click', this.filterModels.bind(this))
      })

      Array.from(this.popupLinks).forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault()
          if (this.querySelector('.modelsGalleryPopupOpen') !== el) this.querySelector('.modelsGalleryPopupOpen')?.classList.remove('modelsGalleryPopupOpen');
          el.classList.toggle('modelsGalleryPopupOpen', !el.classList.contains('modelsGalleryPopupOpen'))
          this.menu.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          })
        })
      })

      Array.from(this.items).forEach(el => {
        this.itemHandle(el)
      })

      Array.from(this.popups).forEach(el => {
        el.style.setProperty('--height', `${el.scrollHeight}px`)
      })

      if(this.popups) {
        document.addEventListener('click', (e) => {
          if(!e.target.closest('.modelsGalleryMenuItemPopup')) document.querySelector('.modelsGalleryPopupOpen')?.classList.remove('modelsGalleryPopupOpen')
        })
      }

      window.addEventListener('resize', () => {
        Array.from(this.popups).forEach(el => {
          el.style.setProperty('--height', `${el.scrollHeight}px`)
        })
      })
    }
    async filterModels(e) {
      const handle = e.target.dataset.handle
      const query = `{
        metaobject(id: "gid://shopify/Metaobject/${handle}") {
          field(key: "models") {
            value
          }
        }
      }`

      const req = await fetch(`/api/2023-07/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '0f06caf0645680db69053c99b7659afc',
        },
        body: JSON.stringify({ query }),
      })
      const res = await req.json()
      const data = res?.data?.metaobject?.field?.value || "[]"

      this.querySelector('.modelsGalleryGrid').innerHTML = ''

      if (JSON.parse(data).length === 0) {
        this.querySelector('.modelsGalleryGrid').innerHTML = `<div class="modelEmptyItem">${theme.strings.no_models_matches}</div>`
      } else {
        const modelsQuery = `{
          ${JSON.parse(data).map((id, i) => `model${i + 1}: metaobject(id: "${id}") {
            bust_measurement: field(key: "bust_measurement") {
              value
            }
            height: field(key: "height") {
              value
            }
            hip_measurement: field(key: "hip_measurement") {
              value
            }
            image_1: field(key: "image_1") {
              reference {
                ... on MediaImage {
                  image {
                    originalSrc
                    src
                  }
                }
              }
            }
            image_2: field(key: "image_2") {
              reference {
                ... on MediaImage {
                  image {
                    originalSrc
                    src
                  }
                }
              }
            }
            model_notes: field(key: "model_notes") {
              value
            }
            name: field(key: "name") {
              value
            }
            size: field(key: "size") {
              value
            }
            waist_measurement: field(key: "waist_measurement") {
              value
            }
          }`).join('')}
        }`

        const modelsReq = await fetch(`/api/2023-07/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '0f06caf0645680db69053c99b7659afc',
          },
          body: JSON.stringify({ query: modelsQuery }),
        })
        const modelsRes = await modelsReq.json()
        const modelsData = modelsRes?.data
        Object.values(modelsData).map(model => {
          const item = document.createElement('div')
          item.className = 'modelItem'
          item.innerHTML = `
            <div class="modelItemImages">
              ${ model?.size?.value ? `<div class="modelItemBadge">${model.size.value}</div>` : '' }
              ${model?.image_1.reference.image.src ? `<img src="${model.image_1.reference.image.src}" class="modelItemImage">` : '' }
              ${model?.image_2.reference.image.src ? `<img src="${model.image_2.reference.image.src}" class="modelItemImage">` : '' }
            </div>
            <div class="modelItemInfo modelsGalleryDesk">
              <div class="modelItemName">${model.name.value}</div>
              ${model?.height.value && model?.size?.value ? `
                <div class="modelItemflex modelItemDetails">
                  <span class="modelItemHeading">model details</span>
                  <span>${model.height.value} wearing ${model.size.value}</span>
                </div>
              ` : "" }
              <div class="modelItemflex modelItemMeasurements">
                <span class="modelItemHeading">more measurements</span>
                <span class="text-link modelMeasurements">click here</span>
              </div>
            </div>
            <div class="modelItemInfoMobi modelsGalleryMobi">
              <div class="modelItemInfoMobiHead">
                ${ model?.name?.value ? `<div class="modelItemName">${model.name.value}</div>` : '' }
                <span class="text-link modelMeasurements">MORE</span>
              </div>
              ${model?.height.value && model?.size?.value ? `
                <div class="modelItemDetails">
                  <div class="modelItemHeading">model details</div>
                  <div>${model.height.value} wearing ${model.size.value}</div>
                </div>
              ` : "" }
            </div>
            <div class="modelsDialog">
              <div class="modelsDialogClose modelsGalleryDesk">[ X ]</div>
              <div class="modelsDialogInner">
                <div class="modelsDialogClose modelsGalleryMobi">[ X ]</div>
                ${ model?.name?.value ? `<div class="modelsDialogHeader">${model.name.value}</div>` : '' }
                <div class="modelsDialogBody">
                  <div class="modelsDialogMeasurementTable">
                    ${ model?.size?.value ? `
                      <div class="modelsDialogMeasurementRow">
                        <div class="modelItemHeading modelsDialogMeasurementCol">Size</div>
                        <div class="modelsDialogMeasurementCol">${model.size.value}</div>
                      </div>
                    ` : '' }
                    ${ model?.height?.value ? `
                      <div class="modelsDialogMeasurementRow">
                        <div class="modelItemHeading modelsDialogMeasurementCol">HEIGHT</div>
                        <div class="modelsDialogMeasurementCol">${model.height.value}</div>
                      </div>
                    ` : '' }
                    ${ model?.bust_measurement?.value ? `
                      <div class="modelsDialogMeasurementRow">
                        <div class="modelItemHeading modelsDialogMeasurementCol">BUST</div>
                        <div class="modelsDialogMeasurementCol">${model.bust_measurement.value}</div>
                      </div>
                    ` : '' }
                    ${ model?.waist_measurement?.value ? `
                      <div class="modelsDialogMeasurementRow">
                        <div class="modelItemHeading modelsDialogMeasurementCol">WAIST</div>
                        <div class="modelsDialogMeasurementCol">${model.waist_measurement.value}</div>
                      </div>
                    ` : '' }
                    ${ model?.hip_measurement?.value ? `
                      <div class="modelsDialogMeasurementRow">
                        <div class="modelItemHeading modelsDialogMeasurementCol">HIP</div>
                        <div class="modelsDialogMeasurementCol">${model.hip_measurement.value}</div>
                      </div>
                    ` : '' }
                  </div>
                  ${model?.model_notes?.value ? `
                    <div class="modelsDialogNote">
                      <div class="modelItemHeading">MODEL NOTES:</div>
                      <div class="modelsDialogNoteContext">${model.model_notes.value}</div>
                    </div>
                  ` : ''}
                </div>
              </div>
            </div>
          `
          this.querySelector('.modelsGalleryGrid').append(item)
          this.itemHandle(item)
        }).join("")
      }

      if (this.optionList) this.optionList.classList.remove('modelsGalleryFilterOptionsOpens')
    }
    itemHandle(el) {
      const closeButtons = el.querySelectorAll('.modelsDialogClose')
      const modelMeasurements = el.querySelectorAll('.modelMeasurements')
      const cta = el.querySelectorAll('.modelItemImage, .modelItemInfoMobi')

      Array.from(modelMeasurements).forEach(el => {
        el.addEventListener('click', () => {
          Array.from(this.querySelectorAll('.modelsDialog')).forEach(d => d.style.display = 'none')
          el.closest('.modelItem').querySelector('.modelsDialog').style.display = "flex"
        })
      })

      Array.from(closeButtons).forEach(el => {
        el.addEventListener('click', () => {
          el.closest('.modelsDialog').style.display = "none"
        })
      })

      Array.from(cta).forEach(el => {
        el.addEventListener('click', () => {
          this.querySelector('.clicked')?.classList.remove('clicked')
          el.closest('.modelItem').classList.add('clicked')
        })
      })
    }
  }

  customElements.define('models-gallery', ModelsGallery)
}

if (typeof customAccordion !== "function") {
  class customAccordion extends HTMLElement {
    static get observedAttributes() {
      return ['class'];
    }
    attributeChangedCallback() {
      console.log(!this.classList.contains('open'), this.querySelector('details[open="true"]'));
      
      if(!this.classList.contains('open') && this.querySelector('details[open="true"]'))
        this.querySelector('details[open="true"] [data-collapsible-trigger]').click()
    }
    constructor() {
      super()
      this.headingEl = this.querySelector('.accordion__title')
      this.bodyEl = this.querySelector('.accordion__body')
      
      this.onClick = this.onClick.bind(this)

      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
      this.headingEl.addEventListener('click', this.onClick);
    }
    onClick() {
      this.classList.toggle('open', !this.classList.contains('open'))
    }
  }

  customElements.define('custom-accordion', customAccordion)
}

/* if (typeof modelsSizes !== "function") {
  class modelsSizes extends HTMLElement {
    constructor() {
      super()
      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
    }
  }

  customElements.define('models-gallery', modelsSizes)
} */

document.addEventListener('DOMContentLoaded', () => {
  const footerCopyright = document.querySelector('.footer__copyright')
  const text_columns_with_images = document.querySelectorAll('.text_columns_with_images')
  const small_newsletter = document.querySelector('.small-newsletter')

  Array.from(text_columns_with_images).forEach(text_columns_with_image => {
    const parent = text_columns_with_image?.querySelector('.grid--mobile-slider')
    const children = parent?.querySelectorAll('.grid-item')
    const next = text_columns_with_image?.querySelector('.grid--slider_next')
    const prev = text_columns_with_image?.querySelector('.grid--slider_prev')
    const sliderNext = text_columns_with_image?.querySelector('.slider__button--next')
    const sliderPrev = text_columns_with_image?.querySelector('.slider__button--prev')
    let currentIndex = 0

    text_columns_with_image?.querySelector('grid-slider')?.toggleSlider()

    next?.addEventListener('click', function () {
      prev.style.display = "block"
      next.style.display = currentIndex == children.length - 2 ? "none" : "block"

      if (sliderNext) {
        sliderNext.click()
      } else {
        if (currentIndex < children.length - 1) {
          currentIndex++
          const nextChild = children[currentIndex]

          nextChild.scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'nearest'
          })
        }
      }
    })

    prev?.addEventListener('click', function () {
      prev.style.display = currentIndex == 1 ? "none" : "block"
      next.style.display = "block"

      if (sliderPrev) {
        sliderPrev.click()
      } else {
        if (currentIndex > 0) {
          currentIndex--
          const prevChild = children[currentIndex]

          prevChild.scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'nearest'
          })
        }
      }
    })
  })

  if (small_newsletter) document.querySelector('html').style.setProperty('--small-newsletter-height', `${parseFloat(small_newsletter.scrollHeight)}px`);

  if (footerCopyright) document.querySelector('html').style.setProperty('--footer-copyright-height', `${parseFloat(footerCopyright.scrollHeight)}px`);
})

setTimeout(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}, 50)

if(/Mac|iPhone|iPad|iPod/i.test(navigator.platform)) {
  document.body.classList.add('iAmIOS')
}